import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';
import { Icon } from 'components/Icons';

const Container = styled.div`
  display: flex;
  align-items: center;

  width: fit-content;
  height: 3.2rem;

  margin: 1.5rem 0;
  padding: 0.8rem 1.6rem;

  background-color: ${pickColor('blueLightSecondary')};
  border-radius: ${({ theme }) => theme.borderRadius.big};
`;

const InfoIcon = styled(Icon)`
  margin-right: 1rem;

  color: ${pickColor('colmarBlue')};

  svg {
    stroke-width: 3;
    font-size: 1.8rem;
  }
`;

const Important = styled(Headline)`
  margin-right: 0.4rem;
`;

const Message = styled(Headline)``;

export { Container, InfoIcon, Important, Message };
